import React from "react";
import { SectionCards } from "../..";
import { mentorshipData } from "../../../assets/data/mentorshipData";

export default function MentorshipSection() {
	return (
		<section className="no-p">
			<SectionCards data={mentorshipData} />
		</section>
	);
}
